import {
  DepartureScheduleT,
  DepartureScheduleFiltersT,
  DepartureScheduleCreateObject,
  DepartureScheduleHistoryItemT,
  DepartureScheduleQueryParams,
} from "@interfaces/departure-schedule";

import Fetcher from "@http/fetcher";
import { ResCallback } from "@interfaces/common";

class DepartureScheduleService {
  static async getAll(params?: DepartureScheduleQueryParams, cb?: ResCallback<DepartureScheduleT[]>) {
    try {
      const res = await Fetcher.get<DepartureScheduleT[]>("/departure-schedule", { params });

      if (res.status === 200 && cb) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async getOne(id: number, cb: ResCallback<DepartureScheduleT>) {
    try {
      const res = await Fetcher.get<DepartureScheduleT>(
        `/departure-schedule/${id}`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async getFilters(cb: ResCallback<DepartureScheduleFiltersT>) {
    try {
      const res = await Fetcher.get<DepartureScheduleFiltersT>(`/departure-schedule/filters`);

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async getFile(id: number, cb: ResCallback<Blob>) {
    try {
      const res = await Fetcher.get<Blob>(
        `/departure-schedule/history/${id}/download`,
        {
          responseType: "blob",
        }
      );

      if (res.status === 200) {
        cb(null, res);
        return res;
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async getExcel(params: DepartureScheduleQueryParams, cb: ResCallback<Blob>) {
    try {
      const res = await Fetcher.get<Blob>(
        `/departure-schedule/download-excel`,
        {
          params,
          responseType: "blob",
        }
      );

      if (res.status === 200) {
        cb(null, res);
        return res;
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async create(
    data: DepartureScheduleCreateObject,
    cb: ResCallback<DepartureScheduleT>
  ) {
    try {
      const res = await Fetcher.post<DepartureScheduleT>(
        "/departure-schedule",
        data
      );

      if (res.status === 201) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async update(
    id: number,
    data: DepartureScheduleCreateObject,
    cb: ResCallback<DepartureScheduleT>
  ) {
    try {
      const res = await Fetcher.patch<DepartureScheduleT>(
        `/departure-schedule/${id}`,
        data
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async delete(id: number, cb: ResCallback<DepartureScheduleT>) {
    try {
      const res = await Fetcher.delete<DepartureScheduleT>(
        `/departure-schedule/${id}`
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async historyCreate(data: FormData, cb: ResCallback<DepartureScheduleHistoryItemT>) {
    try {
      const res = await Fetcher.post<DepartureScheduleHistoryItemT>(`/departure-schedule/history`, data);

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async historyUpdate(id: number, data: FormData, cb: ResCallback<DepartureScheduleT>) {
    try {
      const res = await Fetcher.patch<DepartureScheduleT>(`/departure-schedule/history/${id}`, data);

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async historyDelete(
    historyId: number,
    cb: ResCallback<{ status: boolean }>
  ) {
    try {
      const res = await Fetcher.delete<{ status: boolean }>(`/departure-schedule/history/${historyId}`);

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }

  static async historyAccept(id: number, status: boolean, cb: ResCallback<DepartureScheduleHistoryItemT>) {
    try {
      const res = await Fetcher.patch<DepartureScheduleHistoryItemT>(`/departure-schedule/history/${id}/accept`, { isAccepted: status });

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err) {
      // @ts-ignore
      cb(err);
    }
  }
}

export default DepartureScheduleService;
